import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade createNewModal",
  id: "addBlacklistModal",
  tabindex: "-1",
  ref: "addBlacklistModalRef",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }
const _hoisted_5 = { class: "modal-title fw-bold text-black" }
const _hoisted_6 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = {
  key: 3,
  class: "col-md-6"
}
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = {
  key: 4,
  class: "col-md-6"
}
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = {
  key: 5,
  class: "col-md-6"
}
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_38 = {
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "formRef",
            onSubmit: _ctx.submitForm,
            "validation-schema": _ctx.schema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Code "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "list_code",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Code de la liste réglementaire"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "list_code",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Type d'élément visé "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "entry_type" }, {
                      default: _withCtx(({ field, setValue }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          searchable: true,
                          "track-by": "value",
                          label: "label"
                        }, field, {
                          options: _ctx.entryTypeOptions,
                          "onUpdate:modelValue": (val) => { 
                        setValue(val);
                        _ctx.selectedEntryType = (typeof val === 'object' ? val?.value : val) || null;
                      },
                          placeholder: "Entrer le Type d'élément visé"
                        }), null, 16, ["options", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "entry_type",
                      class: "text-danger"
                    })
                  ])
                ]),
                (_ctx.selectedEntryType === 'PERSON')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Acteur", -1)),
                        _createVNode(_component_Multiselect, {
                          searchable: true,
                          "track-by": "value",
                          label: "label",
                          object: true,
                          options: _ctx.acteursOptions,
                          placeholder: "Sélectionner un acteur",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => {
                      console.log('VAL refffff SELECTIONNE:', val);       
                      console.log('refffffActeur:', val?.refActeur);           
                      _ctx.formRef?.setFieldValue('reference_value', val?.refActeur || String(val?.value || ''));
                    })
                        }, null, 8, ["options"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedEntryType === 'ORGANIZATION')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Organisation "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "reference_value",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Nom de l'organisation"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "reference_value",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedEntryType === 'COUNTRY')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Pays "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Multiselect, {
                          searchable: true,
                          "track-by": "value",
                          label: "label",
                          object: true,
                          options: _ctx.pays,
                          placeholder: "Sélectionner un pays",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = (val) => {
                      console.log('VAL isooooo SELECTIONNE:', val);       
                      console.log('isoooo:', val?.iso2_code);              
                      _ctx.formRef?.setFieldValue('reference_value', val?.iso2_code || '');
                    })
                        }, null, 8, ["options"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedEntryType === 'PORT')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Port", -1)),
                        _createVNode(_component_Multiselect, {
                          options: _ctx.ports,
                          searchable: true,
                          loading: _ctx.loadingPorts,
                          placeholder: "Rechercher (nomPort ou locode)...",
                          label: "label",
                          "track-by": "value",
                          object: true,
                          onSearchChange: _ctx.searchPort,
                          "filter-results": false,
                          "min-chars": 2,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = (val) => {
                      console.log('VAL locode SELECTIONNE:', val);       
                      console.log('locodeee:', val?.locode);
                      _ctx.formRef?.setFieldValue('reference_value', val?.locode || '');
                    })
                        }, null, 8, ["options", "loading", "onSearchChange"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedEntryType === 'SHIP')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Navire", -1)),
                        _createVNode(_component_Multiselect, {
                          options: _ctx.navires,
                          searchable: true,
                          loading: _ctx.loadingNavires,
                          placeholder: "Rechercher (nom, MMSI ou IMO)...",
                          label: "label",
                          "track-by": "value",
                          object: true,
                          onSearchChange: _ctx.searchNavire,
                          "filter-results": false,
                          "min-chars": 2,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = (val) => {
                      console.log('VAL imoooo SELECTIONNE:', val);       
                      console.log('imoooo:', val?.imo);
                      _ctx.formRef?.setFieldValue('reference_value', val?.imo || '');
                    })
                        }, null, 8, ["options", "loading", "onSearchChange"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedEntryType && _ctx.selectedEntryType !== 'ORGANIZATION')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Référence "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "reference_value",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black bg-light",
                          readonly: "",
                          placeholder: _ctx.referencePlaceholder
                        }, null, 8, ["placeholder"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "reference_value",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Raison "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "reason",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer la raison ou contexte de l'inscription sur la liste"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "reason",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Niveau de risque associé "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "risk_level" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          searchable: true,
                          "track-by": "value",
                          label: "label"
                        }, field, {
                          options: _ctx.niveauOptions,
                          placeholder: "Sélectionner le niveau de risque"
                        }), null, 16, ["options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "risk_level",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Autorité ou source "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "source_authority",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer l'autorité"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "source_authority",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Identifiants supplémentaires ", -1)),
                    _createVNode(_component_Field, {
                      name: "additional_identifiers",
                      as: "textarea",
                      class: "form-control shadow-none fs-md-15 text-black",
                      rows: "4",
                      placeholder: "{\"alias\": [\"ABC Corp\"], \"registration_number\": \"12345\"}"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "additional_identifiers",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date d'entrée en vigueur de l'inscription ", -1)),
                    _createVNode(_component_Field, {
                      name: "effective_from",
                      type: "date",
                      class: "form-control shadow-none fs-md-15 text-black"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de fin de validité éventuelle. ", -1)),
                    _createVNode(_component_Field, {
                      name: "effective_to",
                      type: "date",
                      class: "form-control shadow-none fs-md-15 text-black"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Activer", -1)),
                    _cache[20] || (_cache[20] = _createTextVNode()),
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-danger" }, "*", -1)),
                    _createVNode(_component_Field, {
                      name: "is_active",
                      type: "checkbox",
                      class: "form-check-input",
                      value: true,
                      "unchecked-value": false
                    })
                  ])
                ]),
                _createElementVNode("button", _hoisted_38, _toDisplayString(_ctx.btntext), 1)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close shadow-none",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetValue()))
        })
      ])
    ])
  ], 512))
}